import { Gamecloud } from "../../gamecloud";
import { StatusUI, createStatusUIInstances } from "./statusUI";

class Status extends Gamecloud {
  public constructor(private ui: StatusUI) {
    super();
    this.checkStatus();
  }

  private checkStatus() {
    window.setInterval(() => {
      if (this.ui.isServerOnline()) {
        this.ui.showHiddenElementsIfServerOnline();
        // this.ui.hideElementsIfServerOnline();
      } else {
        this.ui.hideElementsIfServerOffline();
        // this.ui.showElementsIfServerOnline();
      }
    }, 5000);
  }
}

export function initStatus() {
  return createStatusUIInstances().map((ui: StatusUI) => {
    return new Status(ui);
  })
}
